import { MapIcon, ListIcon, InfoIcon } from '../primitives/Icon';
import { SegmentedNav, type Segment } from './SegmentedNav';
import styles from './BottomTabs.module.css';

export type TabId = 'map' | 'list' | 'info';

interface Props {
  active: TabId;
  onChange: (id: TabId) => void;
  /** Which tabs to render. Defaults to all three (mobile). */
  tabs?: TabId[];
  /**
   * Render the bar inert (unfocusable, hidden from AT) — set while a modal
   * surface (e.g. the vendor BottomSheet) is open on top of it.
   */
  inert?: boolean;
}

const TAB_META: Record<TabId, Segment<TabId>> = {
  map: { id: 'map', label: 'Map', Icon: MapIcon },
  list: { id: 'list', label: 'List', Icon: ListIcon },
  info: { id: 'info', label: 'Info', Icon: InfoIcon },
};

const DEFAULT_TABS: TabId[] = ['map', 'list', 'info'];

/**
 * Mobile bottom tab bar. Pure chrome wrapper (background, safe-area
 * padding) around the shared SegmentedNav primitive.
 */
export function BottomTabs({ active, onChange, tabs = DEFAULT_TABS, inert = false }: Props) {
  if (tabs.length === 0) return null;
  const segments = tabs.map((id) => TAB_META[id]);
  return (
    <div className={styles.bar} inert={inert}>
      <SegmentedNav segments={segments} active={active} onChange={onChange} size="md" />
    </div>
  );
}
